import React from "react";

/** Build a title + bullet list tip for AI preset cards. */
export function presetTip(title, bullets = []) {
  return (
    <div className="aftp-tip">
      <p className="aftp-tip__title">{title}</p>
      <ul className="aftp-tip__list">
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    </div>
  );
}
